import {IconProps} from '../../types/IconProps'

const IconRadioGreenCheck = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '20'}
      height={height || '21'}
      viewBox='0 0 20 21'
      fill='none'
    >
      <path
        d='M10 0.75C8.07164 0.75 6.18657 1.32183 4.58319 2.39317C2.97982 3.46451 1.73013 4.98726 0.992179 6.76884C0.254225 8.55042 0.061142 10.5108 0.437348 12.4021C0.813554 14.2934 1.74215 16.0307 3.10571 17.3943C4.46928 18.7579 6.20656 19.6865 8.09787 20.0627C9.98919 20.4389 11.9496 20.2458 13.7312 19.5078C15.5127 18.7699 17.0355 17.5202 18.1068 15.9168C19.1782 14.3134 19.75 12.4284 19.75 10.5C19.7473 7.91498 18.7192 5.43661 16.8913 3.60872C15.0634 1.78084 12.585 0.75273 10 0.75ZM14.2806 8.78063L9.03063 14.0306C8.96097 14.1004 8.87826 14.1557 8.78721 14.1934C8.69616 14.2312 8.59857 14.2506 8.5 14.2506C8.40144 14.2506 8.30385 14.2312 8.2128 14.1934C8.12175 14.1557 8.03903 14.1004 7.96938 14.0306L5.71938 11.7806C5.57865 11.6399 5.49959 11.449 5.49959 11.25C5.49959 11.051 5.57865 10.8601 5.71938 10.7194C5.86011 10.5786 6.05098 10.4996 6.25 10.4996C6.44903 10.4996 6.6399 10.5786 6.78063 10.7194L8.5 12.4397L13.2194 7.71937C13.2891 7.64969 13.3718 7.59442 13.4628 7.5567C13.5539 7.51899 13.6515 7.49958 13.75 7.49958C13.8486 7.49958 13.9461 7.51899 14.0372 7.5567C14.1282 7.59442 14.2109 7.64969 14.2806 7.71937C14.3503 7.78906 14.4056 7.87178 14.4433 7.96283C14.481 8.05387 14.5004 8.15145 14.5004 8.25C14.5004 8.34855 14.481 8.44613 14.4433 8.53717C14.4056 8.62822 14.3503 8.71094 14.2806 8.78063Z'
        fill={color || '#00B383'}
      />
    </svg>
  )
}

export default IconRadioGreenCheck
